export default __webpack_public_path__ + "static/map-3f6e1ddb342185a26c476daa59c3a805.png";